import {
  Divider,
  ICommonImageProps,
  Image,
  Link,
  List,
  ListItem,
  Typography,
} from "./atom";
import { Stepper } from "./organism";

// TODO: When we added Image component, it runs errors on dev mode
export const MDXComponents = {
  a: Link,
  code: (props: any) => <Typography as="code" {...props} />,
  h1: (props: any) => <Typography as="h1" {...props} />,
  h2: (props: any) => <Typography as="h2" {...props} />,
  h3: (props: any) => <Typography as="h3" {...props} />,
  h4: (props: any) => <Typography as="h4" {...props} />,
  h5: (props: any) => <Typography as="h5" {...props} />,
  h6: (props: any) => <Typography as="h6" {...props} />,
  hr: Divider,
  img: ({ src, alt }: ICommonImageProps) => (
    <Image
      provider="default"
      src={src}
      alt={alt}
      position="centered"
      showCaption
      width={859}
      height={318}
    />
  ),
  ul: List,
  ol: (props: any) => <List type="numeric" {...props} />,
  li: ListItem,
  p: (props: any) => <Typography as="p" {...props} />,
  strong: (props: any) => <Typography as="strong" {...props} />,
  blockquote: (props: any) => <Typography as="blockquote" {...props} />,
  Stepper: (props: any) => <Stepper showDivider {...props} />,
};
